import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import MUITypography from './MUITypography';
import { align_center } from '../Styles/VMStyles';
import { ADMIN_OTP_PENDING } from '../Util/VMConstants';

const ConfirmationDialog = ({ open, title, message, onClose, onConfirm, okOnly = false }) => {
  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>
        <MUITypography sx={align_center} >{title || "Confirm"}</MUITypography>
      </DialogTitle>
      <DialogContent>
        <Typography>{message || "Are you sure you want to continue?"}</Typography>
      </DialogContent>
      <DialogActions sx={okOnly ? { justifyContent: "center", pb: 2 } : undefined}>
        {okOnly ? (
          <Button onClick={onClose} color="primary" variant="contained" sx={{ minWidth: 120 }}>
            OK
          </Button>
        ) : (
          <>
            <Button onClick={onClose} color="primary" variant="outlined">
              Cancel
            </Button>
            {message !== ADMIN_OTP_PENDING && (
              <Button onClick={onConfirm} color="error" variant="contained">
                Confirm
              </Button>
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmationDialog;